module.exports = __webpack_public_path__ + "img/ELLY_Logo_als_Pfad.7783486e.svg";